import React from 'react';
import { useSite } from '../../context/SiteContext';

export const MobileStickyCTA = () => {
  const { settings, products } = useSite();

  const bestDeal = products?.find((p) => p.is_featured) || products?.[0];

  if (!bestDeal) return null;

  return (
    <div className="mobile-sticky-cta md:hidden">
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className="text-xs text-slate-600">Best Deal</div>
          <div className="font-heading text-2xl font-black" style={{ color: settings?.accent_color }}>
            ${bestDeal.price}
            <span className="text-sm font-normal text-slate-600">/bottle</span>
          </div>
        </div>
        <a
          href={bestDeal.buy_link || '#order'}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta px-6 py-3 rounded-full font-bold text-sm flex-shrink-0"
          data-testid="mobile-sticky-cta"
        >
          ORDER NOW
        </a>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
